import { render, staticRenderFns } from "./WithdrawalStatus.vue?vue&type=template&id=33abe16a&scoped=true&"
import script from "./WithdrawalStatus.vue?vue&type=script&lang=js&"
export * from "./WithdrawalStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33abe16a",
  null
  
)

export default component.exports